function udm_(e) {
    var t = "comScore=", n = document, r = n.cookie, i = "", s = "indexOf", o = "substring", u = "length", a = 2048,
        f,
        l = "&ns_", c = "&", h, p, d, v, m = window, g = m.encodeURIComponent || escape;
    if (r[s](t) + 1)for (d = 0, p = r.split(";"), v = p[u]; d < v; d++)h = p[d][s](t), h + 1 && (i = c + unescape(p[d][o](h + t[u])));
    e += l + "_t=" + +(new Date) + l + "c=" + (n.characterSet || n.defaultCharset || "") + "&c8=" + g(n.title) + i + "&c7=" + g(n.URL) + "&c9=" + g(n.referrer), e[u] > a && e[s](c) > 0 && (f = e[o](0, a - 8).lastIndexOf(c), e = (e[o](0, f) + l + "cut=" + g(e[o](f + 1)))[o](0, a)), n.images ? (h = new Image, m.ns_p || (self.ns_p = h), h.src = e) : n.write("<", "p", "><", 'img src="', e, '" height="1" width="1" alt="*"', "><", "/p", ">")
}

udm_('http' + (document.location.href.charAt(4) == 's' ? 's://sb' : '://b') + '.scorecardresearch.com/b?c1=2&c2=7715761&ns_site=' + ns_site + '&voc_site=' + voc_site + '&name=' + voc_name + '&voc_se=' + voc_se + '&voc_s1=' + voc_s1 + '&voc_s2=' + voc_s2 + '&voc_s3=' + voc_s3 + '&voc_s4=' + voc_s4 + '&voc_tn=' + voc_tn + '&voc_ho=' + voc_ho + '&voc_tc=' + voc_tc + '&voc_tcnew=' + voc_tcnew + '&voc_ed=' + voc_ed + '&voc_au=' + voc_au + '&voc_fep=' + voc_fep + '&voc_fem=' + voc_fem + '&voc_or=' + voc_or + '&voc_pr=' + voc_pr + '&voc_pl=' + voc_pl + '&voc_pu=' + voc_pu + '&voc_usrid=' + voc_usrid + '&voc_tusr=' + voc_tusr + '&voc_usrcp=' + voc_usrcp + '&voc_usrgen=' + voc_usrgen + '&voc_usrag=' + voc_usrag + '&voc_ate=' + voc_ate + '&voc_adb=' + voc_adb + '&voc_top=' + voc_top + '&voc_ntop=' + voc_ntop + '&voc_adp=' + voc_adp + '&voc_krux=' + voc_krux + '&voc_swipe=' + voc_swipe + '&modulosRotacion=' + modulosRotacion + '&idNoticia=' + idNoticia + '');

window.ns_onclick = function (q, f, u, b, o) {
    var eventURL = "";
    var c1_match = "";
    var c2_match = "";
    var i = window, l = i.ns_p, m = l && l.src, s = "&ns_", h = document.referrer.replace(/\/$/, ""),
        f = f || q.href, o = o || "", j = {t: 0, o: 0}, e = "",
        c = /\bc1=[^&]+\b/i, g = /\bc2=[^&]+\b/i, p = (i.encodeURIComponent ? encodeURIComponent : escape),
        n = "3.1212.07";
    if (m && (c1_match = l.src.match(c)) && !c.test(u)) {
        e += "&" + c1_match
    }
    if (m && (c2_match = l.src.match(g)) && !g.test(u)) {
        e += "&" + c2_match
    }
    if (m) {
        var t = l.src, k = t.indexOf("?");
        eventURL = t.substr(0, k > -1 ? k : t.length) + "?"
    }
    eventURL = [eventURL, u, e, s, "type=", b, s, "action=view", s, "_t=", +new Date, h ? s + "referrer=" + p(h) : "", s, "sc_sv=", n, s, "sc_href=", p(f).substr(0, 1000)].join("");
    var r = q && q.target ? q.target.replace(/^_/, "") : "self", d = new Image();
    if (i[r]) {
        j.t = (function (w, v, a) {
            return function () {
                clearTimeout(a.o);
                d.onload = d.onerror = function () {
                    return
                };
                i[w].location.href = v
            }
        })(r, f, j);
        j.o = setTimeout(j.t, 5000);
        d.onload = d.onerror = j.t
    } else {
        i.open(f, r, o)
    }
    d.src = eventURL;
    return false
};



// WEBPACK FOOTER //
// ./src/tracking/comscore.js